{
  "headTitle": "Флоу",
  "empty": {
    "title": "Добавьте первую ноду",
    "hint": "Нажмите «+», дважды кликните по доске или вызовите меню правой кнопкой мыши.\nМожно перетащить сюда картинку, видео или аудио.\nКартинку из буфера обмена вставьте через Ctrl+V или ⌘V."
  },
  "switcher": {
    "aria": "Доски флоу",
    "create": "Новая доска",
    "renameTitle": "Переименовать доску",
    "renameName": "Название",
    "deleteTitle": "Удалить доску",
    "deleteConfirm": "Удалить «{{title}}»? Ноды этой доски будут удалены."
  },
  "viewport": {
    "map": "Карта",
    "showMap": "Показать карту",
    "hideMap": "Скрыть карту",
    "zoomMenu": "Масштаб, {{percent}}",
    "zoom100": "Масштаб 100%",
    "zoomFit": "Вместить всё",
    "addNode": "Добавить ноду",
    "arrange": "Упорядочить ноды",
    "arrangeSelection": "Упорядочить выбранные",
    "arrangeBoard": "Упорядочить доску"
  },
  "menu": {
    "upload": "Загрузить файл",
    "library": "Выбрать из библиотеки",
    "image": "Изображение",
    "video": "Видео",
    "videoTransition": "Видео переход",
    "audio": "Аудио",
    "upscale": "Улучшение видео",
    "depth": "Карта глубины",
    "shot": "Шот",
    "character": "Герой",
    "location": "Локация",
    "prop": "Реквизит",
    "noCharacters": "В проекте нет героев",
    "noLocations": "В проекте нет локаций",
    "noProps": "В проекте нет реквизита",
    "newShot": "Новый",
    "back": "Назад",
    "noScenes": "В проекте нет сцен",
    "shotsLoading": "Загрузка…",
    "shotsLoadFailed": "Не удалось загрузить шоты",
    "episode": "Серия {{label}}",
    "delete": "Удалить ноду",
    "edit": "Редактировать",
    "createChain": "Создать цепочку",
    "regenerate": "Сгенерировать",
    "editChain": "Править цепочку",
    "duplicate": "Дублировать",
    "chainActions": "Действия с цепочкой",
    "search": "Найти ноду, героя, локацию…",
    "searchIn": "Поиск: {{title}}",
    "searchConnect": "Что подключить?",
    "noResults": "Ничего не найдено по «{{query}}»",
    "noChains": "Цепочек пока нет",
    "pin": "Закрепить",
    "unpin": "Открепить",
    "filters": {
      "all": "Все",
      "gen": "Генерация",
      "media": "Медиа",
      "project": "Проект",
      "chains": "Цепочки"
    },
    "sections": {
      "pinned": "Закреплённые",
      "gen": "Генерация",
      "media": "Медиа",
      "project": "Из проекта",
      "chains": "Цепочки",
      "nodes": "Ноды",
      "connect": "Можно подключить"
    },
    "subs": {
      "generate": "Генерация",
      "videoTransition": "Первый кадр, последний или оба",
      "postProduction": "Постпродакшн",
      "depth": "Черно-белая или цветная",
      "upload": "Картинка или видео с диска",
      "audio": "Аудиофайл с диска",
      "library": "Ассеты проекта",
      "shot": "Из раскадровки",
      "chain": "Цепочка"
    },
    "counts": {
      "characters_one": "{{count}} герой",
      "characters_few": "{{count}} героя",
      "characters_many": "{{count}} героев",
      "characters_other": "{{count}} героя",
      "locations_one": "{{count}} локация",
      "locations_few": "{{count}} локации",
      "locations_many": "{{count}} локаций",
      "locations_other": "{{count}} локации",
      "props_one": "{{count}} предмет",
      "props_few": "{{count}} предмета",
      "props_many": "{{count}} предметов",
      "props_other": "{{count}} предмета",
      "shots_one": "{{count}} шот",
      "shots_few": "{{count}} шота",
      "shots_many": "{{count}} шотов",
      "shots_other": "{{count}} шота"
    }
  },
  "node": {
    "empty": "Результата пока нет",
    "uploadingPercent": "{{percent}}%",
    "upscaleEmpty": "Подключите видео",
    "depthEmpty": "Подключите видео",
    "failed": "Генерация не удалась",
    "shotMissing": "Шот недоступен",
    "chainMissing": "Цепочка удалена",
    "characterMissing": "Герой недоступен",
    "locationMissing": "Локация недоступна",
    "propMissing": "Проп недоступен",
    "untitled": "Без названия",
    "rename": "Название",
    "openAsset": "Открыть {{name}}",
    "download": "Скачать оригинал",
    "kinds": {
      "upload": "Файл",
      "library": "Библиотека",
      "image": "Изображение",
      "video": "Видео",
      "video_transition": "Видео переход",
      "audio": "Аудио",
      "video_upscale": "Улучшение",
      "video_depth": "Глубина",
      "chain": "Цепочка",
      "shot": "Шот",
      "character": "Герой",
      "location": "Локация",
      "prop": "Проп"
    }
  },
  "player": {
    "mute": "Без звука",
    "unmute": "Включить звук"
  },
  "edges": {
    "input": "Референсы",
    "output": "Изображение",
    "videoInput": "Видео",
    "videoOutput": "Видео",
    "entityOutput": "Сущность",
    "audioOutput": "Аудио",
    "shotInput": "Связи шота",
    "firstFrame": "Первый кадр",
    "lastFrame": "Последний кадр",
    "makeKeyframe": "Сделать опорным кадром",
    "references": "Подключённые референсы"
  },
  "versions": {
    "title": "Версии",
    "deleteConfirm": "Удалить эту версию?"
  },
  "column": {
    "boardAssistant": "Ассистент доски",
    "nodeAssistant": "Ассистент ноды",
    "prompt": "Промпт",
    "assistant": "Ассистент",
    "generate": "Сгенерировать",
    "generating": "Генерация…",
    "promptPlaceholder": "Опишите кадр",
    "framesRequired": "Подключите первый кадр, последний или оба",
    "frameSlotEmpty": "Подключите изображение",
    "referencesEmpty": "Прикрепите референсы связями на доске",
    "promptRequired": "Нет промпта",
    "modelRequired": "Нет модели"
  },
  "chain": {
    "created": "Цепочка создана",
    "duplicated": "Цепочка дублирована",
    "run": "Запустить",
    "running": "В процессе…",
    "image": "Изображение",
    "video": "Видео",
    "attachHint": "Прикрепите ноду к цепочке на вход",
    "upload": "Загрузить файл",
    "library": "Библиотека",
    "disconnect": "Отключить",
    "back": "Назад",
    "backTo": "Назад к {{title}}",
    "delete": "Удалить",
    "deleteTitle": "Удалить цепочку",
    "deleteConfirm": "Удалить «{{title}}»? Поставленные ноды останутся без цепочки.",
    "renameTitle": "Переименовать цепочку",
    "input": "Вход",
    "makeInput": "Сделать входом",
    "cancelInput": "Отменить",
    "inputEmpty": "Вход цепочки",
    "inputEmptyHint": "Файл подставится при использовании цепочки",
    "starterChoice": "Сгенерируйте или сделайте входом цепочки",
    "nestedInputs": "У этой цепочки есть свои входы. Добавьте входные ноды, подключите их и отметьте как входы."
  },
  "depth": {
    "variant": "Цвет",
    "gray": "Черно-белая",
    "color": "Цветная",
    "model": "Video Depth Anything Small"
  },
  "upscale": {
    "source": "Источник",
    "needsSource": "Подключите видео или шот",
    "video": "Видео",
    "disconnect": "Отсоединить",
    "model": "Модель",
    "version": "Версия",
    "noModels": "Нет доступных моделей улучшения"
  },
  "bulk": {
    "title": "Сгенерировать",
    "cancel": "Отмена",
    "confirm": "Сгенерировать",
    "summary": "Будет сгенерировано {{list}} на сумму {{price}}.",
    "summaryUnknown": "Будет сгенерировано {{list}}.",
    "and": "и",
    "quoteFailed": "Не удалось посчитать стоимость",
    "startFailed": "Не удалось запустить генерацию",
    "queued": "Нода уже в очереди на генерацию",
    "deleteTitle": "Нода ожидает генерацию",
    "deleteNode": "Эта нода ожидает генерацию. Если удалить её, она и всё, что от неё зависит в этом запуске, не будет сгенерировано.",
    "deleteNodes": "Некоторые ноды ожидают генерацию. Если удалить их, они и всё, что от них зависит в этом запуске, не будут сгенерированы.",
    "deleteEdge": "Если удалить связь, всё, что от неё зависит в этом запуске, не будет сгенерировано.",
    "kinds": {
      "image_one": "{{count}} изображение",
      "image_few": "{{count}} изображения",
      "image_many": "{{count}} изображений",
      "image_other": "{{count}} изображения",
      "video_one": "{{count}} видео",
      "video_few": "{{count}} видео",
      "video_many": "{{count}} видео",
      "video_other": "{{count}} видео",
      "video_transition_one": "{{count}} видео переход",
      "video_transition_few": "{{count}} видео перехода",
      "video_transition_many": "{{count}} видео переходов",
      "video_transition_other": "{{count}} видео перехода",
      "video_upscale_one": "{{count}} улучшение",
      "video_upscale_few": "{{count}} улучшения",
      "video_upscale_many": "{{count}} улучшений",
      "video_upscale_other": "{{count}} улучшения",
      "video_depth_one": "{{count}} карта глубины",
      "video_depth_few": "{{count}} карты глубины",
      "video_depth_many": "{{count}} карт глубины",
      "video_depth_other": "{{count}} карты глубины",
      "chain_one": "{{count}} цепочка",
      "chain_few": "{{count}} цепочки",
      "chain_many": "{{count}} цепочек",
      "chain_other": "{{count}} цепочки",
      "shot_one": "{{count}} шот",
      "shot_few": "{{count}} шота",
      "shot_many": "{{count}} шотов",
      "shot_other": "{{count}} шота"
    }
  },
  "errors": {
    "createFailed": "Не удалось создать доску",
    "renameFailed": "Не удалось переименовать доску",
    "deleteFailed": "Не удалось удалить доску",
    "nodeFailed": "Не удалось обновить ноду",
    "generateFailed": "Не удалось запустить генерацию"
  }
}
